<template>
  <div class="academic">
    <h1 class="title">·唐老师采访专题</h1>
    <div class="academic-list">
      <!-- 'https://oss.dayaedu.com/website/daya-teatang.mp4' -->
      <a class="acadmic-item" @click="toggleShow(1)">
        <img src="../../assets/images/suggest/teacgerTang.jpg" width="100%" alt />
        <p>唐老师专访-介绍</p>
      </a>
    </div>
    <h1 class="title">·管乐团介绍</h1>
    <div class="academic-list">
      <a class="acadmic-item" @click="toggleShow(2)">
        <img src="../../assets/images/suggest/yuetuan.jpg" alt />
        <p>大雅乐盟介绍</p>
      </a>
      <!-- <a class="acadmic-item" @click="toggleShow(3)">
        <img src="../../assets/images/suggest/yuetuan.jpg" alt />
        <p>乐团介绍</p>
      </a> -->
    </div>
    <div class="popupVideo" v-if="videoStatus">
      <div class="mask" @click="toggleShow"></div>
      <div class="videoContent">
        <video :src="videoSrc" class="video" controls autoplay></video>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
.academic {
  min-height: 500px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.11);
  .title {
    padding-left: 32px;
    padding-bottom: 20px;
    color: #08433f;
    font-size: 25px;
    line-height: 55px;
    font-weight: bold;
    &:nth-child(1) {
      padding-top: 25px;
    }
  }

  .academic-list {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    flex-wrap: wrap;
    -webkit-flex-wrap: wrap;
    padding-left: 59px;
    .acadmic-item {
      margin: 0 17px 20px;
      flex: 0 0 266px;
      // box-shadow: 6px 2px 20px 0px rgba(0, 0, 0, 0.06);
      border-radius: 6px;
      overflow: hidden;
      img {
        width: 266px;
        height: 175px;
      }
      p {
        width: 250px;
        line-height: 42px;
        padding: 0 8px;
        color: #444;
        font-size: 14px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        box-sizing: border-box;
      }
    }
  }
  .mask {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
  }
}
</style>

<script>
export default {
  name: "theme",
  data() {
    return {
      videoStatus: false,
      videoSrc: "https://oss.dayaedu.com/website/dayaedu-detail.mp4", // 默认视频地址
    };
  },
  methods: {
    toggleShow(id) {
      // this.videoSrc = src;
      this.videoSrc = id;
      this.$router.push({ path: "/articleInfo" + id });
      return;
      // this.videoStatus = !this.videoStatus;
    },
  },
};
</script>
